import { render, staticRenderFns } from "./MerchantLog.vue?vue&type=template&id=0005fae3&scoped=true"
import script from "./MerchantLog.vue?vue&type=script&lang=js"
export * from "./MerchantLog.vue?vue&type=script&lang=js"
import style0 from "./MerchantLog.vue?vue&type=style&index=0&id=0005fae3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005fae3",
  null
  
)

export default component.exports